import { render, staticRenderFns } from "./ProvisionalApprovalModal.vue?vue&type=template&id=519c78ed&scoped=true&"
import script from "./ProvisionalApprovalModal.vue?vue&type=script&lang=js&"
export * from "./ProvisionalApprovalModal.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionalApprovalModal.vue?vue&type=style&index=0&id=519c78ed&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519c78ed",
  null
  
)

export default component.exports